import { Button, Checkbox, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, FormControlLabel, Grid, InputLabel, List, ListItem, ListItemText, MenuItem, Select, TextField, Typography, Radio, RadioGroup, FormLabel, Box } from '@mui/material';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { addInvoicesCustomer } from '../../../../redux/actions/InvoicesActions';
import useAlert from '../../../../hooks/useAlert';
import { validateAddInvoicesCustomer } from '../../../../utils/validation';
import { ImCancelCircle } from 'react-icons/im';
import {IoMdSave } from 'react-icons/io';

export const InvoiceCustomerAddPopUpModal = ({ openDialog, handleCloseDialog }) => {
  const [person, setPerson] = useState("legal-entity");

  const handleChange = (event) => {
    setPerson(event.target.value);
  }

  const dispatch = useDispatch();
  const authUserId = useSelector(state => state?.auth?.user?.id);
  const { showSuccessAddInvoicesCustomer, showErrorAlertAddInvoicesCustomer } = useAlert();
  const [userValue, setUserValue] = useState({
    name: '',
    mail: '',
    type: '',
    phone: '',
    identifier: '',
    country: '',
    detail: '',
    province: '',
    district: '',
  });

  const [formErrors, setFormErrors] = useState({});

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setUserValue((prevUserValue) => ({
      ...prevUserValue,
      [name]: value
    }));
    setFormErrors({ ...formErrors, [name]: '' });
  };

  const handleCheckboxChange = (event) => {
    setUserValue({
      ...userValue,
      [event.target.name]: event.target.checked,
    });
  };

  const addInvoiceCustomer = async () => {
    userValue.userId = authUserId;
    userValue.type = person === 'legal-entity' ? 2 : 1;
    const errors = validateAddInvoicesCustomer(userValue);
    setFormErrors(errors);
    if (Object.keys(errors).length === 0) {
      try {
        await dispatch(addInvoicesCustomer(userValue));
        showSuccessAddInvoicesCustomer();
        setUserValue({
          name: '',
          mail: '',
          type: '',
          phone: '',
          identifier: '',
          country: '',
          detail: '',
          province: '',
          district: '',
        });
        handleCloseDialog();
      } catch (err) {
        showErrorAlertAddInvoicesCustomer();
        console.error("Invoice Customer add failed:", err);
      }
    }
  };

  return (
    <Dialog open={openDialog} onClose={handleCloseDialog} maxWidth="md" fullWidth>
        <Box
                sx={{
                    padding: 2,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    mb: 3,
                    backgroundColor: '#fff',
                    borderRadius: 2,
                    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
                }}
            >
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <Box sx={{ width: 4, height: 24, backgroundColor: '#b71c1c', mr: 1 }} />
                    <Typography
                        variant="h6"
                        color="black"
                        sx={{ textTransform: 'uppercase', letterSpacing: '0.08em' }}
                    >
                        Yeni Müşteri Kaydet
                    </Typography>
                </Box>
            </Box>
      <DialogContent  >
        <Grid container spacing={3} sx={{ marginTop: 1 }}>
          <Grid item xs={12} md={12}>
            <TextField
              size='small'

              fullWidth
              label="Müşteri Adı"
              variant="outlined"
              placeholder="Ad Soyad (Firma Adı)"
              value={userValue.name}
              name="name"
              onChange={handleInputChange}
              error={!!formErrors.name}
              helperText={formErrors.name}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              size='small'

              fullWidth
              label="Mail Adresi"
              variant="outlined"
              placeholder="E -posta"
              value={userValue.mail}
              name="mail"
              onChange={handleInputChange}
              error={!!formErrors.mail}
              helperText={formErrors.mail}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              size='small'

              onChange={handleInputChange}
              value={userValue.phone}
              name="phone"
              fullWidth
              label="Telefon"
              variant="outlined"
              placeholder="Telefon"
              error={!!formErrors.phone}
              helperText={formErrors.phone}
            />
          </Grid>

          <Grid item xs={12} md={12}>
            <TextField
              size='small'

              onChange={handleInputChange}
              value={userValue.country}
              fullWidth
              name="country"
              label="Ülke"
              variant="outlined"
              placeholder="Ülke"
              error={!!formErrors.country}
              helperText={formErrors.country}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField
              size='small'

              onChange={handleInputChange}
              value={userValue.province}
              fullWidth
              name="province"
              label="İl"
              variant="outlined"
              placeholder="İl"
              error={!!formErrors.province}
              helperText={formErrors.province}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              size='small'

              onChange={handleInputChange}
              value={userValue.district}
              fullWidth
              name="district"
              label="İlçe"
              variant="outlined"
              placeholder="İlçe"
              error={!!formErrors.district}
              helperText={formErrors.district}
            />
          </Grid>
          <Grid item xs={12} md={12}>
            <TextField
              size='small'

              fullWidth
              label="Açık Adres"
              variant="outlined"
              placeholder="Açık adres giriniz"
              value={userValue.detail}
              name="detail"
              onChange={handleInputChange}
              error={!!formErrors.detail}
              helperText={formErrors.detail}
              multiline
              rows={4}
            />
          </Grid>

          <Grid item xs={12} md={12}>
            <FormLabel component="legend">Müşteri Türü</FormLabel>
            <RadioGroup
              row
              aria-labelledby="person"
              name="person"
              value={person}
              onChange={handleChange}
            >
              <FormControlLabel
                value="legal-entity"
                control={<Radio />}
                label="Tüzel Kişi"
                sx={{ marginRight: 20 }}
              />
              <FormControlLabel
                value="natural-person"
                control={<Radio />}
                label="Gerçek Kişi"
                sx={{ marginLeft: 20 }}
              />
            </RadioGroup>
          </Grid>
          {person !== 'legal-entity' && (
            <Grid item xs={12} md={6}>
              <TextField
                size='small'

                onChange={handleInputChange}
                value={userValue.identifier}
                fullWidth
                name="identifier"
                label="Vergi Kimlik No / TC Kimlik No"
                variant="outlined"
                placeholder="VKN/TCKN"
                error={!!formErrors.identifier}
                helperText={formErrors.identifier}
              />
            </Grid>
          )}
          {/* Vergi Dairesi sadece Tüzel Kişi seçildiğinde görünür */}
          {person === 'legal-entity' && (
            <Grid item xs={12} md={6}>
              <TextField
                size='small'

                onChange={handleInputChange}
                value={userValue.identifier}
                fullWidth
                name="identifier"
                label="Vergi Dairesi"
                variant="outlined"
                placeholder="Vergi Dairesi"
                error={!!formErrors.identifier}
                helperText={formErrors.identifier}
              />
            </Grid>
          )}

          <Grid item xs={12} display="flex" justifyContent="flex-end">
            <Button
              onClick={addInvoiceCustomer}
              variant="contained"
              startIcon={<IoMdSave />}
              sx={{
                borderRadius: 18,
                backgroundColor: '#1F1B45',
                color: '#FFFFFF',
                textTransform: 'none',
                fontWeight: 500,
                fontSize: '0.875rem',
                padding: '10px 20px',
                display: 'flex',
                alignItems: 'center',
                gap: 1,
                '&:hover': {
                  backgroundColor: '#2C285A',
                },
              }}
            >
              Kaydet
            </Button>
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};
